/** Imperative open for the Hub in-app browser (same chrome as attachment preview). */

export type HubInAppBrowserListener = (url: string | null) => void;

const listeners = new Set<HubInAppBrowserListener>();

export function subscribeHubInAppBrowser(listener: HubInAppBrowserListener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function openHubInAppBrowser(url: string): void {
  const href = (url || "").trim();
  if (!href) return;
  for (const listener of listeners) listener(href);
}

export function closeHubInAppBrowser(): void {
  for (const listener of listeners) listener(null);
}

export function browserTitleForUrl(url: string): string {
  try {
    const parsed = new URL(url);
    return parsed.hostname.replace(/^www\./i, "") || parsed.href;
  } catch {
    return url;
  }
}
